import { useCallback, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { getServicePagePath } from "../../../../services/navigation/navigateToRoute";
import type { AppRouterPaths } from "../../../../services/navigation/types";
import { useAppDispatch } from "../../../../services/redux/hooks/use-dispatch";
import {
  addStorageObject,
  fetchAllStorageObjects,
  fetchAllStorageObjectsSharing,
} from "../actions/actions";
import { setCurrentService, setSelectedObjectId } from "../slice";
import { StorageScope } from "../../../../services/api/instances/storageApi/types/service_types";
import { ObjectType } from "../../../../services/api/instances/storageApi/types/object_types";

export const useStorageObject = (
  service: StorageScope,
  pathName: keyof AppRouterPaths,
  currentService: StorageScope | null,
) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (service !== currentService) {
      dispatch(setCurrentService(service));
    }
  }, [service, currentService]);

  useEffect(() => {
    dispatch(fetchAllStorageObjects({ service: service as StorageScope }));
    dispatch(fetchAllStorageObjectsSharing());
  }, [service]);

  const addObject = useCallback(
    (name: string, objectType: ObjectType) => {
      dispatch(addStorageObject({ name, service, objectType })).unwrap();
    },
    [service],
  );

  const handleSelectObject = useCallback(
    (id: string) => {
      dispatch(
        setSelectedObjectId({
          service: service as StorageScope,
          id,
        }),
      );
      navigate(getServicePagePath(id, pathName));
    },
    [service],
  );

  return {
    addObject,
    handleSelectObject,
  };
};
